/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'
import React from 'react'

import { Link } from '@/i18n/navigation'
import { isAuthenticatedAtom } from '@/store/session'

/**
 * A link to the login page if the user is not logged in, or the dashboard if the user is logged in.
 */
const HeaderLoginLink: React.FC = () => {
  const t = useTranslations('HeaderLoginLink')
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)

  return isAuthenticated ? (
    <Link href={'/dashboard'}>{t('dashboardLinkText')}</Link>
  ) : (
    <Link href={'/login'}>{t('loginLinkText')}</Link>
  )
}

export { HeaderLoginLink }
